import script from "./Text.vue?vue&type=script&setup=true&lang=js"
export * from "./Text.vue?vue&type=script&setup=true&lang=js"

import "./Text.vue?vue&type=style&index=0&id=1950dd1c&lang=scss&scoped=true"

import exportComponent from "/media/dolar/office/office_project/oneGov-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1950dd1c"]])

export default __exports__